import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React__default from 'react';
import { classNames } from '../../../helpers/classnames.js';

var ListItem = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React__default.createElement("li", __assign({ "data-testid": "ListItem" }, props, { className: classNames('dsb_list-item', className) })));
};

export { ListItem };
